


























































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, Product, SurveyStatusType } from "@/interfaces";

import { SurveyModule } from "@/store";
import { getInfopointHospitality, deleteInfopointHospitality } from "@/services";
import { notifyError, notifySuccess } from "@/common/notify";

import { date } from "quasar";

@Component
export default class HospitalityInfoPoint extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  elements: Product[] = [];

  loading = false;

  filteredData: Product[] = [];

  searchText = "";

  async mounted() {
    try {
      this.elements = await getInfopointHospitality();
      this.setSurveyType(SurveyType.INFOPOINT);
      this.filteredData = this.elements;
    } catch (error) {
      console.log(error);
    }
  }

  goToSurvey() {
    this.$router.push(`survey/${SurveyType.INFOPOINT}`).catch(error => console.log(error));
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.elements.filter(element =>
        element.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.elements;
    }
  }

  openShowAttractor(element: Product) {
    if (element.surveys.length > 0) {
      this.$router.push(`survey/${SurveyType.INFOPOINT}/${element.surveys[0].id}`).catch(error => console.log(error));
    }
  }

  getAttractorDate(element: Product) {
    if (element.surveys.length > 0) {
      return date.formatDate(element.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
    }

    return "";
  }

  onDeleteAttractor(element: Product) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare il punto informativo <strong>${element.name}</strong>`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteAttractorAction(element);
      });
  }

  async deleteAttractorAction(element: Product) {
    try {
      await deleteInfopointHospitality(element.id);
      this.elements = await getInfopointHospitality();
      this.filteredData = this.elements;
      this.searchText = "";
      notifySuccess("Punto informativo rimosso con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare il punto informativo!");
    }
  }

  get statusLabelClass() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "Completato";
        case SurveyStatusType.IN_PROGRESS:
          return "Da Completare";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: Product) => (row.surveys.length > 0 ? this.statusLabel(row.surveys[0].status) : ""),
        align: "left",
        sortable: true,
      },
      {
        label: "Ultima modifica",
        name: "date",
        field: (row: Product) =>
          row.surveys.length > 0 ? date.formatDate(row.surveys[0].updated_at, "DD/MM/YYYY HH:mm") : "",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "complete", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
